module.exports = __webpack_public_path__ + "static/media/class_small_deathknight.44129737.png";